module.exports = __webpack_public_path__ + "../../../static/img/c_im_29.e598ec85.png";